'use client';

import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="flex size-full items-start justify-center overflow-y-auto py-20">
      <div className="max-w-4xl p-6 leading-7">
        <h1 className="mb-4 text-2xl font-bold">プライバシーポリシー</h1>
        <p>
          株式会社KUDEN
          WORLD（以下「当社」といいます。）は、当社の提供するサービス（以下「本サービス」といいます。）における、ユーザーについての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。なお、本ポリシーで特に定義されている文言を除き、用語の定義は個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び当社利用規約に準ずるものとします。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第1条　個人情報の取得</h2>
        <p>
          当社は、予め通知・公表した利用目的の達成に必要な範囲の個人情報を、適正かつ適法な手段により取得します。また、15
          歳未満の子供から法定代理人（親権者等）の同意なく個人に関する情報をみだりに収集しないよう留意します。
          なお、当社は個人情報の主体であるご本人（以下「ご本人」といいます。）に関する次に掲げる個人情報を取得します。
        </p>
        <div>
          <p>(1) 本人確認に関する情報</p>
          <p>(2) サービス利用に関する情報</p>
          <p>(3) クレジットカード情報その他決済に関する情報</p>
          <p>(4) ご本人の肖像を含む静止画情報</p>
          <p>(5) その他の情報（ご本人からの問合せ内容、連絡内容等に関する情報）</p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第2条　個人情報利用目的の特定</h2>
        <p>
          当社は、次に掲げる利用目的（以下「本利用目的」といいます。）の範囲内において個人情報を取得及び利用します。
        </p>
        <div>
          <p>(1) 本サービスへの登録及び本サービス利用時の本人認証及び登録ユーザーの管理のため</p>
          <p>(2) 本サービスの提供のため</p>
          <p>(3) 本サービス対価のご請求のため</p>
          <p>(4) 不正行為等の防止及び対応のため</p>
          <p>(5) 本サービスの保守、管理のため</p>
          <p>(6) マーケティングデータの調査及び分析、並びにマーケティング施策の検討及び実施のため</p>
          <p>(7) 当社又は第三者の媒体において本サービスの提供、勧誘、広告その他マーケティングをするため</p>
          <p>(8) 本サービス改善及び新サービス提供のため</p>
          <p>(9) 本ポリシーに基づく第三者提供</p>
          <p>(10) 本サービスに関する当社規約、ポリシー等規程の変更などを通知するため</p>
          <p>(11) その他当社内部管理のため</p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第3条　個人情報利用の制限</h2>
        <p>
          当社は、ご本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取扱うことはありません。ただし、次の場合はこの限りではありません。
        </p>
        <div>
          <p>(1) 法令に基づく場合</p>
          <p>
            (2) 人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき
          </p>
          <p>
            (3)
            公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき
          </p>
          <p>
            (4)
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          </p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第4条　個人情報利用目的の変更</h2>
        <p>
          当社は、個人情報の利用目的を変更する場合には、変更前の利用目的と関連性を有すると合理的に認められる範囲を超えては行わず、変更された利用目的について、ご本人に通知し、または本ポリシー上に公表します。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第5条　個人情報の安全管理・従業員の監督</h2>
        <p>
          当社ウェブサイトやリンク等に関するお問い合わせは、「お問い合わせ」入力フォームにて、当社までご連絡ください。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第6条　委託先の監督</h2>
        <p>
          当社は、個人情報の取扱いの全部または一部を委託する場合は、委託先と機密保持を含む契約の締結、または、当社が定める約款に合意を求め、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第7条　第三者提供の制限</h2>
        <p>当社は、次に掲げる場合を除くほか、あらかじめご本人の同意を得ないで、個人情報を第三者に提供しません。</p>
        <div>
          <p>(1) 法令に基づく場合</p>
          <p>
            (2) 人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき
          </p>
          <p>
            (3)
            公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき
          </p>
          <p>
            (4)
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          </p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第8条　開示の請求</h2>
        <p>
          当社は、ご本人から、個人情報の開示、第三者提供記録の開示を求められたときは、ご本人に対し、遅滞なく開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。なお、アクセスログなどの個人情報以外の情報については、原則として開示いたしません。
        </p>
        <div>
          <p>(1) ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</p>
          <p>(2) 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</p>
          <p>(3) 他の法令に違反することとなる場合</p>
          <p>(4) 開示の請求がご本人からであることが確認できない場合</p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第9条　個人情報の訂正等</h2>
        <p>
          当社は、ご本人から、個人情報が真実でないという理由によって、内容の訂正、追加または削除(以下「訂正等」といいます)を求められた場合には、他の法令の規定により特別の手続きが定められている場合を除き、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨をご本人に通知します。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第10条　個人情報の利用停止等</h2>
        <p>
          当社は、ご本人から、ご本人の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由、または偽りその他不正の手段により取得されたものであるという理由により、その利用の停止または消去、第三者提供の停止(以下「利用停止等」といいます。)を求められた場合には、遅滞なく必要な調査を行い、その結果に基づき、個人情報の利用停止等を行い、その旨をご本人に通知します。ただし、個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、ご本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じます。
        </p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第11条　手続き</h2>
        <p>1. 第８～第１０条に基づき、請求をする場合は以下の窓口までお問合せください。</p>
        <div className="pl-4">
          <p>住所：〒150-0013 東京都渋谷区恵比寿1-16-26 協和ビル1F</p>
          <p>株式会社KUDEN WORLD</p>
          <p>個人情報取扱責任者：柳下聖也</p>
          <p>連絡先：info@eplga.co.jp</p>
        </div>
        <br />
        <p>2. 第８条に基づく請求については、1回の請求につき1,000円の手数料をいただきます。</p>
        <h2 className="mb-4 mt-6 text-xl font-bold">第12条　理由の説明</h2>
        <p>
          当社は、ご本人からの要求にもかかわらず、次のいずれかの事項を決定する場合、その旨をご本人に通知する際に理由を説明するよう努めます。
        </p>
        <div>
          <p>(1) 利用目的を通知しない場合</p>
          <p>(2) 個人情報の全部または一部を開示しない場合</p>
          <p>(3) 個人情報の利用停止等を行わない場合</p>
          <p>(4) 個人情報の第三者提供を停止しない場合</p>
        </div>
        <h2 className="mb-4 mt-6 text-xl font-bold">第13条　お問い合わせ</h2>
        <p>当社のプライバシーポリシーに関するお問い合わせは、下記担当までお願いいたします。</p>
        <br />
        <p>〒150-0013 東京都渋谷区恵比寿1-16-26 協和ビル1F</p>
        <p>株式会社KUDEN WORLD プライバシーポリシー管理担当</p>
      </div>
    </div>
  );
}
